import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AppShell } from "@/components/layout/AppShell";
import { InstallerStage } from "@/components/layout/DeviceFrame";
import { applyTheme, readTheme } from "@/lib/theme";
import { onSeedVersionChange } from "@/lib/api";
import { toast } from "sonner";
import OversiktPage from "@/pages/OversiktPage";
import LeveranserPage from "@/pages/LeveranserPage";
import LeveranseDetaljPage from "@/pages/LeveranseDetaljPage";
import EndringPage from "@/pages/EndringPage";
import PlanPage from "@/pages/PlanPage";
import ServicePage from "@/pages/ServicePage";
import ServiceDetaljPage from "@/pages/ServiceDetaljPage";
import KunderPage from "@/pages/KunderPage";
import KundeDetaljPage from "@/pages/KundeDetaljPage";
import MontorPage from "@/pages/MontorPage";
import MontorJobbPage from "@/pages/MontorJobbPage";
import KundeVisningPage from "@/pages/KundeVisningPage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
  useEffect(() => { applyTheme(readTheme()); }, []);
  useEffect(() => onSeedVersionChange(() => {
    toast("Eksempeldataene er oppdatert", { description: "Demoøkten din er lastet inn på nytt med det nyeste datasettet.", id: "seed-refresh" });
  }), []);
  return (
    <TooltipProvider delayDuration={200}>
      <BrowserRouter>
        <Routes>
          <Route path="/kunde/:token" element={<KundeVisningPage />} />
          <Route path="/montor" element={<InstallerStage><MontorPage /></InstallerStage>} />
          <Route path="/montor/:deliveryId" element={<InstallerStage><MontorJobbPage /></InstallerStage>} />
          <Route element={<AppShell />}>
            <Route path="/" element={<Navigate to="/oversikt" replace />} />
            <Route path="/oversikt" element={<OversiktPage />} />
            <Route path="/leveranser" element={<LeveranserPage />} />
            <Route path="/leveranser/:id" element={<LeveranseDetaljPage />} />
            <Route path="/leveranser/:id/endring/:changeId" element={<EndringPage />} />
            <Route path="/leveranser/:id/endring" element={<EndringPage />} />
            <Route path="/plan" element={<PlanPage />} />
            <Route path="/service" element={<ServicePage />} />
            <Route path="/service/:id" element={<ServiceDetaljPage />} />
            <Route path="/kunder" element={<KunderPage />} />
            <Route path="/kunder/:id" element={<KundeDetaljPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors={false} closeButton />
    </TooltipProvider>
  );
}

export default App;
